import { FormattedMessage } from 'react-intl';

import { Menu } from '../../../../../navigation/menu/Menu.js';
import { useDataTableV2 } from '../../../contexts/DataTableV2Context.js';

/**
 * A component providing the sub menu with the functionalities to download data
 * @internal
 */
export const DataTableV2DownloadData = () => {
  const table = useDataTableV2();

  return (
    <Menu.Sub>
      <Menu.SubTrigger>
        <FormattedMessage
          defaultMessage="Download as CSV"
          id="TggAMlvVC8+HSDg6"
          description="Download table as CSV"
        />
      </Menu.SubTrigger>
      <Menu.SubContent>
        <Menu.Item
          onSelect={() => {
            table.downloadAllData();
          }}
        >
          <FormattedMessage
            defaultMessage="All"
            id="6DkhRjOwso7wlIuQ"
            description="Download the entire page"
          />
        </Menu.Item>
        {table.options.enablePagination && (
          <Menu.Item
            onSelect={() => {
              table.downloadPageData();
            }}
          >
            <FormattedMessage
              defaultMessage="Current page"
              id="tSmzmDq7B63VRiyp"
              description="Download only the current page"
            />
          </Menu.Item>
        )}
        {table.options.enableRowSelection && (
          <Menu.Item
            disabled={table.getSelectionCount() === 0}
            onSelect={() => {
              table.downloadSelectedData();
            }}
          >
            <FormattedMessage
              defaultMessage="Selected rows ({noOfRows})"
              id="2oIUuMt/P4lbKJs8"
              description="Download the selected rows"
              values={{
                noOfRows: table.getSelectionCount(),
              }}
            />
          </Menu.Item>
        )}
      </Menu.SubContent>
    </Menu.Sub>
  );
};
